module.exports = __webpack_public_path__ + "img/fileImg1.5575a624.png";